var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "star_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.121569 0 0 0 0 0.690196 0 0 0 0 0.968627 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1FB0F7",
    strokeWidth: 4.667,
    d: "m26.478 47.832-8.627 2.977a4.667 4.667 0 0 1-6.188-4.496l.165-9.125a4.667 4.667 0 0 0-.94-2.895L5.39 27.008a4.667 4.667 0 0 1 2.363-7.274l8.73-2.663a4.667 4.667 0 0 0 2.462-1.79l5.23-7.478a4.667 4.667 0 0 1 7.648 0l5.23 7.479a4.667 4.667 0 0 0 2.463 1.79l8.729 2.662a4.667 4.667 0 0 1 2.363 7.274l-5.496 7.285a4.667 4.667 0 0 0-.941 2.895l.165 9.125a4.667 4.667 0 0 1-6.188 4.496l-8.627-2.977a4.667 4.667 0 0 0-3.044 0Z"
  }))));
};
export default SvgStar;